/**
 * Controller: TemplatesCreatePricingAccounts
 */
angular.module('acme.application.templates.create.pricing.accounts.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.templates',
  'acme.common.service.discounts',
  'acme.common.service.validate',
  'acme.common.factory.wizard',
  'acme.view.application.templates.showAccountsModal.controllers'
])
.controller('TemplatesCreatePricingAccountsController', [ '$scope', '$timeout', '$uibModal', 'ApiService', 'TemplatesService', 'DiscountsService', 'ValidateService', 'WizardFactory', '$window', function($scope, $timeout, $uibModal, ApiService, TemplatesService, DiscountsService, ValidateService, WizardFactory, $window) {

    $scope.templatesCreatePricingAccounts = {

      template: {},
      showModal: {},

      wizard: {},

      discountCodes: [],

      accountDiscounts: [],
      accountCategories: [],

      hasAccountDiscounts: false,
      areAccountDiscountsDirty: false,

      discountsLoaded: false,
      categoriesLoaded: false,

      init: function() {

        this.initWizard(true);

        ValidateService.addFieldTests(this.wizard.getStep('accounts').validators);

        $scope.$on('TemplatesService::Update', this.onTemplatesServiceUpdate);
        $scope.$on('DiscountsService::Update', this.onDiscountsServiceUpdate);

        $scope.$on('TemplatesCreateController::Save', this.onTemplatesCreateControllerSave);
        $scope.$on('TemplatesCreatePricing::Update', this.onTemplatesCreatePricingUpdate);

        this.getAccountCategories();
      },

      initWizard: function(validate) {
        var self = $scope.templatesCreatePricingAccounts;

        this.wizard = new WizardFactory();
        this.wizard.init({
          name: 'accounts',
          validators: [{
            field: 'templates-create-pricing-accounts-discount-loaded',
            equal: {
              message: 'Please wait...',
              test: function() {
                return [self.discountsLoaded, true];
              }
            }
          }, {
            field: 'templates-create-pricing-accounts-discount',
            equal: {
              message: 'You can have only one discount per organization category',
              test: function() {
                if (self.template.memberOnlyEvent) {
                  return [true, true];
                }else{
                  return [TemplatesService.hasValidDiscounts(self.accountDiscounts, "accountCategory"), true];
                }
              }
            }
          }, {
            field: 'templates-create-pricing-accounts-discount-selected',
            equal: {
              message: 'Please select a category and discount',
              test: function() {
                if (self.template.memberOnlyEvent) {
                  return [true, true];
                }else {
                  return [TemplatesService.hasDiscounts(self.accountDiscounts, "accountCategory"), true];
                }
              }
            }
          }]
        });

        if (validate) {
          this.validate();
        }
      },

      validate: function() {
        this.wizard.validate();
        $timeout(function() {
          $scope.$emit('TemplatesCreatePricingController::TabCheck', {
            tab: 'accounts',
            invalid: $scope.templatesCreatePricingAccounts.wizard.hasErrors('accounts')
          });
        }, 0);
      },

      getAccountCategories: function() {
        this.categoriesLoaded = false;
        ApiService.partners.categories.list({
          page: 1,
          pageSize: -1,
          sortDirection: "asc",
          sortField: "name"
        }).then(this.success.getAccountCategories, this.error.getAccountCategories);
      },

      getAccountDiscounts: function() {
        this.discountsLoaded = false;
        if (!this.areAccountDiscountsDirty) {
          ApiService.partners.templates.detail(this.template.id).then(this.success.getAccountDiscounts, this.error.getAccountDiscounts);
        }
      },

      findDiscountCode: function(id) {
        return DiscountsService.find(id);
      },

      checkAccountDiscounts: function() {
        if (this.accountDiscounts instanceof Array && this.accountDiscounts.length > 0) {
          this.hasAccountDiscounts = true;
        }else{
          this.hasAccountDiscounts = false;
        }
      },

      addAccountDiscount: function() {
        this.accountDiscounts.push({
          accountCategory: {},
          discountCode: {}
        });
        this.checkAccountDiscounts();
        this.areAccountDiscountsDirty = true;
      },

      removeAccountDiscount: function(index) {
        console.log('templatesCreatePricingAccounts::removeAccountDiscount', index);

        this.accountDiscounts.splice(index, 1);
        this.checkAccountDiscounts();
        this.areAccountDiscountsDirty = true;
      },

      findAccountCategory: function(id) {
        var i, ii,
          r = false;

        for (i=0,ii=this.accountCategories.length;i<ii;i++) {
          if (id === this.accountCategories[i].id) {
            r = {
              index: i,
              category: this.accountCategories[i]
            };
            break;
          }
        }

        return r;
      },

      processAccountDiscounts: function(discounts) {
        var i, ii;

        // APP-5100: Diagnostic — detect when processAccountDiscounts is about to wipe existing
        // account discounts because the incoming payload is empty/null. This is a distinct
        // path from save_skipped: the data is destroyed in memory before any save occurs.
        var hasExistingDiscounts = this.accountDiscounts instanceof Array && this.accountDiscounts.length > 0;
        var incomingIsEmpty = !discounts || discounts.length === 0;

        if (hasExistingDiscounts && incomingIsEmpty) {
          var metadata = {
            existingAccountDiscountsCount: this.accountDiscounts.length,
            hasIncomingPayload: !!discounts,
            templateId: this.template ? this.template.id : null,
            discountsLoaded: this.discountsLoaded,
            areAccountDiscountsDirty: this.areAccountDiscountsDirty,
          };

          console.warn('[APP-5100] processAccountDiscounts called with empty payload — existing account discounts will be wiped:', metadata);

          if ($window.Bugsnag) {
            $window.Bugsnag.notify(
              new Error('[APP-5100] processAccountDiscounts called with empty payload — existing account discounts will be wiped'),
              function (event) {
                event.context = 'templates.pricing.accounts.accounts_wiped_on_update';
                event.severity = 'warning';
                event.addMetadata('accountsState', metadata);
              }
            );
          }
        }

        this.savedAccountDiscounts = discounts;
        this.accountDiscounts = [];
        for (i=0,ii=this.savedAccountDiscounts.length;i<ii;i++) {
          this.accountDiscounts.push({
            id: this.savedAccountDiscounts[i].id,
            accountCategory: this.findAccountCategory(this.savedAccountDiscounts[i].categoryId).category,
            discountCode: this.findDiscountCode(this.savedAccountDiscounts[i].discountId).code
          });
        }
        this.checkAccountDiscounts();
      },

      showAccounts: function(accountCategoryId) {
        var self = $scope.templatesCreatePricingAccounts;

        self.showModal = $uibModal.open({
          templateUrl: 'views/application/views/templates/modals/showAccountsModal.tpl.html',
          size: 'md',
          controller: 'TemplatesShowAccountsModalController',
          resolve: {
            AccountsListData: function() {
              return ApiService.partners.categories.detail(accountCategoryId);
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.showModal.result.then(function () {
          // Do nothing
        }, function () {
          // Do nothing
        });
      },

      save: function() {
        var i, ii,
            accounts = [];

        this.validate();

        if (this.template.id && !this.wizard.hasErrors('accounts')) {
          for (i = 0, ii = this.accountDiscounts.length; i < ii; i++) {
            // Update if there is already an ID
            if (this.accountDiscounts[i] && (this.accountDiscounts[i].accountCategory || this.accountDiscounts[i].discountCode)) {
              accounts.push({
                id: this.accountDiscounts[i].id || null,
                eventTemplateId: this.template.id,
                categoryId: (this.accountDiscounts[i].accountCategory && this.accountDiscounts[i].accountCategory.id) ? this.accountDiscounts[i].accountCategory.id : null,
                discountId: (this.accountDiscounts[i].discountCode && this.accountDiscounts[i].discountCode.id) ? this.accountDiscounts[i].discountCode.id : null
              });
            }
          }

          ApiService.partners.templates.update({
            eventTemplateId: this.template.id,
            data: accounts
          }).then(this.success.save, this.error.save);
        }
      },

      success: {
        getAccountCategories: function(response) {
          var self = $scope.templatesCreatePricingAccounts;

          self.accountCategories = response.data.payload.list;
          self.categoriesLoaded = true;

        },
        
        getAccountDiscounts: function(response) {
          var self = $scope.templatesCreatePricingAccounts;

          self.processAccountDiscounts(response.data.payload);
          self.discountsLoaded = true;
        },

        save: function(response) {}
      },

      error: {
        getAccountCategories: function(response) {
          var self = $scope.templatesCreatePricingAccounts;

          self.error.generic(response);
          self.categoriesLoaded = true;
        },
        getAccountDiscounts: function(response) {
          var self = $scope.templatesCreatePricingAccounts;

          self.error.generic(response);
          self.discountsLoaded = true;
        },
        save: function(response) {
          $scope.templatesCreatePricingAccounts.error.generic(response);
        },
        generic: function(response) {
          $scope.$emit('TemplatesCreateController::Error', { message: response.data.error });
        }
      },

      onTemplatesCreateControllerSave: function(e, data) {
        var self = $scope.templatesCreatePricingAccounts;

        if (self.discountsLoaded && self.categoriesLoaded) {
          self.save();
        } else {
          // APP-5100: Diagnostic — account discounts were NOT saved during this save broadcast
          // because loading flags weren't ready. Same race condition as member rules.
          var metadata = {
            discountsLoaded: self.discountsLoaded,
            categoriesLoaded: self.categoriesLoaded,
            templateId: self.template ? self.template.id : null,
          };

          console.warn('[APP-5100] Account discounts skipped during save — loading flags not ready:', metadata);

          if ($window.Bugsnag) {
            $window.Bugsnag.notify(
              new Error('[APP-5100] Account discounts skipped during save — loading flags not ready'),
              function (event) {
                event.context = 'templates.pricing.accounts.save_skipped';
                event.severity = 'warning';
                event.addMetadata('accountsState', metadata);
              }
            );
          }
        }
      },

      onDiscountsServiceUpdate: function(e, data) {
        var self = $scope.templatesCreatePricingAccounts;

        self.discountCodes = DiscountsService.getModel();
        self.discountsLoaded = true;
        self.validate();
      },

      onTemplatesServiceUpdate: function(e, data) {
        var self = $scope.templatesCreatePricingAccounts;

        self.template = TemplatesService.getModel();

        // Next Tick
        $timeout(function() {
          self.getAccountDiscounts();
        }, 0);
      },

      onTemplatesCreatePricingUpdate: function(e, data) {
        var self = $scope.templatesCreatePricingAccounts;

        if (data.view === 'accounts') {
          self.template = TemplatesService.getModel();

          // Next Tick
          $timeout(function () {
            self.getAccountDiscounts();
          }, 0);
        }
      }

    };

    $scope.templatesCreatePricingAccounts.init();

}]);